export default __webpack_public_path__ + "static/media/shop3.55d39821.png";